import styles from "./CTA.module.css";
import { siteConfig } from "../../siteConfig";

export function CTA() {
  return (
    <section id="contact" className={styles.section} aria-labelledby="cta-heading">
      <div className="container">
        <div className={`${styles.panel} on-dark`}>
          <span className="eyebrow">Contact</span>
          <h2 id="cta-heading">Ready to Put Your Brand Out There?</h2>
          <p>Tell us what you want to be seen — we&rsquo;ll help bring it to life.</p>

          <div className={styles.ctaRow}>
            <a href={siteConfig.contact.phoneHref} className="btn btn-primary">
              Call Us — {siteConfig.contact.phoneDisplay}
            </a>
            {/* <a
              href={siteConfig.contact.whatsappHref}
              className="btn btn-outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp Us — {siteConfig.contact.whatsappDisplay}
            </a> */}
          </div>

          <span className={styles.location}>
            {siteConfig.location.city}, {siteConfig.location.state}
          </span>
        </div>
      </div>
    </section>
  );
}
